import { Modal } from 'antd';
import React, { FC } from 'react';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import styles from './videoModal.module.scss';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  loading?: boolean;
}

const VideoModal: FC<VideoModalProps> = ({
  isOpen,
  onClose,
  videoUrl,
  loading,
}) => {
  return (
    <Modal
      width={800}
      footer={null}
      open={isOpen}
      wrapClassName={styles.demoVideo}
      onCancel={onClose}
      maskClosable={false}
      centered
      destroyOnClose>
      <div className={styles.videoContainer}>
        {loading ? (
          <LoaderAnimation />
        ) : (
          <video
            data-testid="video"
            controls
            autoPlay
            controlsList="nodownload"
            disablePictureInPicture
            className={styles.video}>
            <source src={videoUrl} type="video/mp4" />
            Sorry, your browser doesn't support videos.
          </video>
        )}
      </div>
    </Modal>
  );
};

export default VideoModal;
